<template lang="pug">
  .col-lg-3
    .card.filter-card
      .card-title 課程地點
      .card-body
        .filter-title 台北市
        .filter-options
          .filter-option
            input.filter_d_checkbox(id="district1" type="checkbox" autocomplete="off")
            label(for="district1") 中山區
          .filter-option
            input.filter_d_checkbox(id="district2" type="checkbox" autocomplete="off")
            label(for="district2") 中山區
        .filter-title 新北市
        .filter-options
          .filter-option
            input.filter_d_checkbox(id="district3" type="checkbox" autocomplete="off")
            label(for="district3") 新店區
          .filter-option
            input.filter_d_checkbox(id="district4" type="checkbox" autocomplete="off")
            label(for="district4") 永和區
          .filter-option
            input.filter_d_checkbox(id="district5" type="checkbox" autocomplete="off")
            label(for="district5") 三重區
          .filter-option
            input.filter_d_checkbox(id="district6" type="checkbox" autocomplete="off")
            label(for="district6") 板橋區
          .filter-option
            input.filter_d_checkbox(id="district7" type="checkbox" autocomplete="off")
            label(for="district7") 土城區
          .filter-option
            input.filter_d_checkbox(id="district8" type="checkbox" autocomplete="off")
            label(for="district8") 林口區
          .filter-option
            input.filter_d_checkbox(id="district9" type="checkbox" autocomplete="off")
            label(for="district9") 中和區
        .filter-title 年齡
        .filter-options
          .filter-option
              input.filter_a_checkbox(id="course_types0" type="checkbox" autocomplete="off")
              label(for="course_types0") 5-8歲課程
</template>

<script>
export default {
  name: "Filter",
};
</script>

<style scoped lang="scss">
@import "@/assets/style/locations/filter.scss";
</style>
